import React, { useState } from "react";
import { Link } from "react-router-dom";
import { sendContactUsEmail } from "../services/nonAuthRequets";
import { toast } from "react-toastify";
const Contact = () => {
  document.title = "Contact Us | Bigmall";
  const [formData, setFormData] = useState({
    customerName: "",
    customerEmail: "",
    customerPhone: "",
    customerMessage: "",
  });
  const [loading, setLoading] = useState(false);
  const mapInputIdToDtoField = (id) => {
    switch (id) {
      case "name":
        return "customerName";
      case "email":
        return "customerEmail";
      case "phone":
        return "customerPhone";
      case "message":
        return "customerMessage";
      default:
        return id;
    }
  };

  const handleChange = (e) => {
    const { id, value } = e.target;
    const field = mapInputIdToDtoField(id);
    setFormData({
      ...formData,
      [field]: value,
    });
  };

  const handleSubmit = async (e) => {
    setLoading(true);
    e.preventDefault();
    try {
      //console.log(formData);
      setFormData({
        customerName: "",
        customerEmail: "",
        customerPhone: "",
        customerMessage: "",
      });
      // Send the form data to the back‑end
      const response = await sendContactUsEmail(formData);
      toast.success("Email sent successfully. We will get back to you soon.");
      setLoading(false);

      // Optionally show a success message to the user here
      //console.log("Email sent successfully", response);
    } catch (error) {
      console.error("Error sending contact email", error);
      toast.error("Error sending email. Please try again later.");
      setLoading(false);
    } finally {
      setLoading(false);
    }
  };
  return (
    <section className="contact py-20">
      <div className="container container-lg">
        <div className="row gy-4">
          <div className="col-lg-8">
            <div className="contact-box border border-gray-100 rounded-16 px-24 py-10">
              <form onSubmit={handleSubmit}>
                <h6 className="text-sm mb-10">Get in Touch</h6>
                <div className="row gy-4">
                  <div className="col-sm-6 col-xs-6">
                    <label
                      htmlFor="name"
                      className="flex-align gap-4 text-sm text-gray-900 fw-semibold mb-10"
                    >
                      Full Name{" "}
                      <span className="text-danger text-xl line-height-1">
                        *
                      </span>{" "}
                    </label>
                    <input
                      type="text"
                      className="common-input-two text-sm"
                      id="name"
                      placeholder="Full name"
                      onChange={handleChange}
                      value={formData.customerName}
                      required
                    />
                  </div>
                  <div className="col-sm-6 col-xs-6">
                    <label
                      htmlFor="email"
                      className="flex-align gap-4 text-sm text-gray-900 fw-semibold mb-10"
                    >
                      Email Address{" "}
                      <span className="text-danger text-xl line-height-1">
                        *
                      </span>{" "}
                    </label>
                    <input
                      type="email"
                      className="common-input-two text-sm"
                      id="email"
                      placeholder="Email address"
                      onChange={handleChange}
                      value={formData.customerEmail}
                      required
                    />
                  </div>
                  <div className="col-sm-6 col-xs-6">
                    <label
                      htmlFor="phone"
                      className="flex-align gap-4 text-sm  text-gray-900 fw-semibold mb-10"
                    >
                      Phone Number
                      <span className="text-danger text-xl line-height-1">
                        *
                      </span>{" "}
                    </label>
                    <input
                      type="number"
                      className="common-input-two text-sm"
                      id="phone"
                      placeholder="Phone Number*"
                      onChange={handleChange}
                      value={formData.customerPhone}
                      required
                    />
                  </div>
                  {/* <div className="col-sm-6 col-xs-6">
                                        <label
                                            htmlFor="subject"
                                            className="flex-align gap-4 text-sm font-heading-two text-gray-900 fw-semibold mb-4"
                                        >
                                            Subject
                                            <span className="text-danger text-xl line-height-1">
                                                *
                                            </span>{" "}
                                        </label>
                                        <input
                                            type="text"
                                            className="common-input px-16"
                                            id="subject"
                                            placeholder="Subject"
                                        />
                                    </div> */}
                  <div className="col-sm-12">
                    <label
                      htmlFor="message"
                      className="flex-align gap-4 text-sm text-gray-900 fw-semibold mb-10"
                    >
                      Message
                      <span className="text-danger text-xl line-height-1">
                        *
                      </span>{" "}
                    </label>
                    <textarea
                      className="common-input-two text-sm"
                      id="message"
                      placeholder="Type your message"
                      // defaultValue={""}
                      onChange={handleChange}
                      value={formData.customerMessage}
                      required
                    />
                  </div>
                  <div className="col-sm-12 mt-20">
                    <button
                      type="submit"
                      className="btn btn-main btn-sm py-10 px-20 rounded-8"
                      disabled={loading}
                    >
                      {loading ? "Sending..." : "Send Message"}
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
          <div className="col-lg-4">
            <div className="contact-box border border-gray-100 rounded-16 px-24 py-40">
              <h6 className="mb-48">How can we help you?</h6>
              <div className="flex-align gap-16 mb-16">
                <span className="w-40 h-40 flex-center rounded-circle border border-gray-100 text-main-600 text-2xl flex-shrink-0">
                  <i className="ph-fill ph-phone-call" />
                </span>
                <div className="flex items-center">
                <Link
                  to="tel:+94777961772"
                  className="text-md text-gray-900 hover-text-main-600"
                >
                  +94 77 796 1772
                </Link>
                <span className="mx-2 text-gray-900">/</span>
                <Link
                  to="tel:+94741337427"
                  className="text-md text-gray-900 hover-text-main-600"
                >
                  +94 74 133 7427
                </Link>
                </div>
              </div>
              <div className="flex-align gap-16 mb-16">
                <span className="w-40 h-40 flex-center rounded-circle border border-gray-100 text-main-600 text-2xl flex-shrink-0">
                  <i className="ph-fill ph-envelope" />
                </span>
                <Link
                  to="mailto:support@bigmall.lk"
                  className="text-md text-gray-900 hover-text-main-600"
                >
                  support@bigmall.lk
                </Link>
              </div>
              {/* <div className="flex-align gap-16 mb-0">
                                <span className="w-40 h-40 flex-center rounded-circle border border-gray-100 text-main-600 text-2xl flex-shrink-0">
                                    <i className="ph-fill ph-map-pin" />
                                </span>
                                <span className="text-md text-gray-900 ">
                                    789 Inner Lane, California, USA
                                </span>
                            </div> */}
            </div>
            {/* <div className="mt-24 flex-align flex-wrap gap-16">
                            <Link
                                to="#"
                                className="bg-neutral-600 hover-bg-main-600 rounded-8 p-10 px-16 flex-between flex-wrap gap-8 flex-grow-1"
                            >
                                <span className="text-white fw-medium">Get Support On Call</span>
                                <span className="w-36 h-36 bg-main-600 rounded-8 flex-center text-xl text-white">
                                    <i className="ph ph-headset" />
                                </span>
                            </Link>
                            <Link
                                to="#"
                                className="bg-neutral-600 hover-bg-main-600 rounded-8 p-10 px-16 flex-between flex-wrap gap-8 flex-grow-1"
                            >
                                <span className="text-white fw-medium">Get Direction</span>
                                <span className="w-36 h-36 bg-main-600 rounded-8 flex-center text-xl text-white">
                                    <i className="ph ph-map-pin" />
                                </span>
                            </Link>
                        </div> */}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;
